import { createContext } from "react";

export const SubscriptionContext = createContext<any | undefined>(undefined);
